import React, { useEffect, useState } from 'react'

import { useLocation } from 'react-router'

import history from 'utils/history'

import { Assessment, FindInPage, Help, Home } from '@mui/icons-material'

import { Modal } from 'components'
import HelpDialog from 'components/ManualAnalysisList/HelpDialog'
import Container from './styles'
import NavigationItem from './NavigationItem'

const Navigation = () => {
  const location = useLocation()
  const [value, setValue] = useState(location.pathname)
  const [helpModalOpen, setHelpModalOpen] = useState(false)

  const handleOnClick = (event) => {
    const route = event.target.getAttribute('data')
    if (route && route !== value) {
      setValue(route)
      history.push(route)
      history.go()
    }
  }

  useEffect(() => {
    if (value !== location.pathname) setValue(location.pathname)
  }, [location.pathname])

  return (
    <Container>
      <NavigationItem
        label="Aplicações"
        href="/"
        value={value}
        icon={<Home fontSize="small" />}
        onClick={handleOnClick}
      />
      <NavigationItem
        label="revisões manuais"
        href="/manual-analisys-audit"
        value={value}
        icon={<FindInPage fontSize="small" />}
        onClick={handleOnClick}
      />
      <NavigationItem
        label="Estatísticas"
        href="/statistics"
        value={value}
        icon={<Assessment fontSize="small" />}
        onClick={handleOnClick}
      />
      <NavigationItem label="Ajuda" href="" icon={<Help fontSize="small" />} onClick={() => setHelpModalOpen(true)} />
      <Modal open={helpModalOpen} onClose={() => setHelpModalOpen(false)} title="Dúvidas Comuns">
        <HelpDialog />
      </Modal>
    </Container>
  )
}

export default Navigation
